module.exports = __webpack_public_path__ + "img/points.af08a4d9.png";